import BaseChart from '../baseChartMap';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for map chart */
//   data: [],
//   /* Set additional options for map chart. */
//   options: {},
//   /* Theme of the map chart. */
//   theme: string,
// };

export default function Map(props) {
  const { className, data, options, ...otherProps } = props;

  return (
    <BaseChart
      className={className}
      data={data}
      options={options}
      type="mapChart"
      {...otherProps}
    />
  );
}
